import { render, staticRenderFns } from "./CompareTVs.vue?vue&type=template&id=3457556b&"
import script from "./CompareTVs.vue?vue&type=script&lang=js&"
export * from "./CompareTVs.vue?vue&type=script&lang=js&"
import style0 from "./CompareTVs.vue?vue&type=style&index=0&id=3457556b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports